import RichText from './rich-text'

export default RichText
